<script>
import {apiStatus, API_STATUS} from "@utils/apiStatus";

export default {
  computed: {
    status() {
      return apiStatus.state.status;
    },
    isDown() {
      return this.status === API_STATUS.DOWN;
    },
    visible() {
      return this.isDown || this.status === API_STATUS.RESTORED;
    },
    copyKey() {
      return this.isDown ? 'apiStatus.down' : 'apiStatus.restored';
    },
  },
};
</script>

<template>
  <div
    role="status"
    aria-live="polite"
    class="tw-fixed tw-inset-x-0 tw-top-3 tw-z-[1100] tw-flex tw-justify-center tw-px-4 tw-pointer-events-none"
  >
    <transition
      mode="out-in"
      enter-active-class="tw-transition tw-duration-200 tw-ease-out"
      enter-class="tw-opacity-0 -tw-translate-y-2"
      leave-active-class="tw-transition tw-duration-200 tw-ease-in"
      leave-to-class="tw-opacity-0 -tw-translate-y-2"
    >
      <div
        v-if="visible"
        :key="status"
        data-testid="api-status-banner"
        class="tw-flex tw-items-start tw-gap-3 tw-w-full tw-max-w-md tw-rounded-xl tw-bg-white tw-px-4 tw-py-3 tw-ring-1 tw-ring-gray-200 tw-shadow-md"
      >
        <div
          :class="['tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-w-9 tw-h-9 tw-rounded-full',
                   isDown ? 'tw-bg-amber-100 tw-text-amber-600' : 'tw-bg-green-100 tw-text-green-600']"
        >
          <i :class="[isDown ? 'fe-cloud-off' : 'fe-check', 'tw-text-lg']" />
        </div>
        <div class="tw-min-w-0 tw-flex-1">
          <div class="tw-text-sm tw-font-semibold tw-text-gray-900">{{ $t(`${copyKey}.title`) }}</div>
          <p class="tw-m-0 tw-mt-0.5 tw-text-xs tw-text-gray-600">{{ $t(`${copyKey}.text`) }}</p>
        </div>
        <b-spinner v-if="isDown" small class="tw-shrink-0 tw-self-center tw-text-gray-400" />
      </div>
    </transition>
  </div>
</template>
